import { MonitoringWrapper } from '@/features/monitoring/components/MonitoringWrapper';

export default function Monitoring() {
  return (
    <div className="flex">
      <MonitoringWrapper />
    </div>
  );
}
